import React from "react";

/**
 * PDP page-data external integration URLs (retired from window.SCHA). Static, page-level
 * configuration projected into the PDP route contract and provided once at the page root.
 * See ADR 0003 / F23 window.SCHA retirement.
 */
export interface PdpWebComponentUrls {
  calculationTabScriptUrl: string;
  mountingMgrWebComponentUrl: string;
  greaseAppWebComponentUrl: string;
  bearingXUrl: string;
}

const PdpWebComponentUrlsContext = React.createContext<PdpWebComponentUrls>({
  calculationTabScriptUrl: "",
  mountingMgrWebComponentUrl: "",
  greaseAppWebComponentUrl: "",
  bearingXUrl: "",
});

export const PdpWebComponentUrlsProvider = PdpWebComponentUrlsContext.Provider;

export const usePdpWebComponentUrls = () => React.useContext(PdpWebComponentUrlsContext);
